

import React from 'react';
import nocloudsIllustration from '@/assets/noclouds.png';
import { EmptyState } from '../EmptyState';

export const FlyerboardEmptyState: React.FC = () => (
    <EmptyState
      title="No flyers currently available from my school"
      description="Check out opportunities fit for my child that were distributed through other schools below."
      illustration={nocloudsIllustration}
    />
  );
